
import { Vue, Component } from "vue-property-decorator";

@Component({})
export default class PrintButton extends Vue {
  onPrint() {
    window.print();
  }
}
